module.exports = __webpack_public_path__ + "img/water8-1.c1b8c509.jpg";